import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import FourCol from '../../partials/FourCol'
import bakery from '../../img/bakery.jpg'
import villaMala from '../../img/villa_mala.jpg'
import soa from '../../img/soa.jpg'
//import ds from '../../img/ds.jpg'
import kucni from '../../img/kucni.jpg'
import scooter from '../../img/scooter.jpg'
import cps from '../../img/cps.jpg'
import hs from '../../img/homeswitch.jpg'
import cs from '../../img/cs.jpg'

function ReferenceSection() {
  const { t } = useTranslation();
  return (
    <section id="projects" className="projectsContainer py-20 mb-0 bg-dark text-white">
      <h2 className='text-center'>{t('myProjects')}</h2>
      <div className='container'>
        <FourCol contentOne={<First />} contentTwo={<Second />} contentThree={<Third />} contentFour={<Fourth />} />
        <FourCol contentOne={<First2 />} contentTwo={<Second2 />} contentThree={<Third2 />} contentFour={<Fourth2 />} />
      </div>
    </section>
  )
}

export default ReferenceSection

function First() {
  const { t, i18n } = useTranslation();

  return (
    <div className="projects bg-indigo text-dark d-flex flex-column">
      <Link to={`/${i18n.language}/${t("bakery")}`} className='coverImg'><img className='image-fluid' src={bakery} alt='Bakery App' /></Link>
      <Link to={`/${i18n.language}/${t("bakery")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">{t('bakeryCardTitle')}</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t('bakeryCardTxt')}</p>
      <Link to={`/${i18n.language}/${t("bakery")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function Second() {
  const { t, i18n } = useTranslation();

  return (
    <div className="projects bg-grey d-flex flex-column">
      <Link to={`/${i18n.language}/${t("kucni")}`} className='coverImg'><img className='image-fluid' src={kucni} alt={t("kucniCardTitle")} /></Link>
      <Link to={`/${i18n.language}/${t("kucni")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">{t("kucniCardTitle")}</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("kucniCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("kucni")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function Third() {
  const { t, i18n } = useTranslation();
  
  return (
    <div className="projects bg-indigo text-dark d-flex flex-column">
      <Link to={`/${i18n.language}/${t("villa")}`} className='coverImg'><img className='image-fluid' src={villaMala} alt='Villa Mala' /></Link>
      <Link to={`/${i18n.language}/${t("villa")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">{t("villaCardTitle")}</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("villaCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("villa")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function Fourth() {
  const { t, i18n } = useTranslation();
  
  return (
    <div className="projects bg-grey d-flex flex-column">
      <Link to={`/${i18n.language}/${t("homeswitch")}`} className='coverImg'><img className='image-fluid' src={hs} alt='Homeswitch' /></Link>
      <Link to={`/${i18n.language}/${t("homeswitch")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">{t("hsCardTitle")}</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("hsCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("homeswitch")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function First2() {
  const { t, i18n } = useTranslation();

  return (
    <div className="projects bg-grey d-flex flex-column">
      <Link to={`/${i18n.language}/${t("cs")}`} className='coverImg'><img className='image-fluid' src={cs} alt='Croatia Soundworks' /></Link>
      <Link to={`/${i18n.language}/${t("cs")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">Croatia Soundworks</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("csCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("cs")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function Second2() {
  const { t, i18n } = useTranslation();

  return (
    <div className="projects bg-indigo text-dark d-flex flex-column">
      <Link to={`/${i18n.language}/${t("soa")}`} className='coverImg'><img className='image-fluid' src={soa} alt='SOA' /></Link>
      <Link to={`/${i18n.language}/${t("soa")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">{t("soaCardTitle")}</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("soaCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("soa")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function Third2() {
  const { t, i18n } = useTranslation();

  return (
    <div className="projects bg-grey d-flex flex-column">
      <Link to={`/${i18n.language}/${t("cps")}`} className='coverImg'><img className='image-fluid' src={cps} alt='SOA' /></Link>
      <Link to={`/${i18n.language}/${t("cps")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">CPS</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("cpsCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("cps")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}

function Fourth2() {
  const { t, i18n } = useTranslation();

  return (
    <div className="projects bg-indigo text-dark d-flex flex-column">
      <Link to={`/${i18n.language}/${t("scooter")}`} className='coverImg'><img className='image-fluid' src={scooter} alt='Bakery App' /></Link>
      <Link to={`/${i18n.language}/${t("scooter")}`}><h3 className="cardTitle my-0 px-20 py-10 text-center">{t("scooterCardTitle")}</h3></Link>
      <p className="px-20 font-md my-0 mb-20">{t("scooterCardTxt")}</p>
      <Link to={`/${i18n.language}/${t("scooter")}`} className='btn btn-sm bg-none align-self-center mb-20'>{t("seeMore")}</Link>
    </div>
  );
}
